import React from 'react';
import DownloadIcon from 'src/common/utils/TableColumnIcons/DownloadIcon';

export const ActionColumnDowload = (value, row, rowIndex, { onDownload }) => {
	
	return (
		<>
			<DownloadIcon onClick={() => onDownload(row)} color="#808080" />
		</>
	);
};